export default __webpack_public_path__ + "static/media/taiga.c6c945d1.svg";